var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"google-pay-button"},_vm.$listeners),[_c('img',{attrs:{"src":_vm.imgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }